<!--legal hub icon-->

<svg xmlns="http://www.w3.org/2000/svg"
     width="23"
     height="23"
     viewBox="2 2 20 20"
     fill="none"
     stroke-width="1.5"
     stroke-linecap="round"
     stroke-linejoin="round"
     stroke="currentColor"
     data-icon-name="legal-hub">
    <path
        d="M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385" />
    <path d="M6 9l4 4" />
    <path d="M13 10l-4 -4" />
    <path d="M3 21h7" />
    <path
        d="M6.793 15.793l-3.586 -3.586a1 1 0 0 1 0 -1.414l2.293 -2.293l.5 .5l3 -3l-.5 -.5l2.293 -2.293a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-2.293 2.293l-.5 -.5l-3 3l.5 .5l-2.293 2.293a1 1 0 0 1 -1.414 0z" />
</svg>


<svg      stroke="currentColor"
          data-icon-name="dragAndDrop"
          viewBox="0 0 24 24" role="presentation" width="25" height="25">
    <path d="M9 7h2v2H9V7zm0 4h2v2H9v-2zm0 4h2v2H9v-2zm4-8h2v2h-2V7zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z" fill-rule="evenodd"></path>
</svg>